import { ApiEndpointClient } from './resource-client';
const USER_API_PREFIX = 'user-api/v1';
export class UsersClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, USER_API_PREFIX);
        this.http = http;
    }
    getCurrentUser = async (options) => {
        return this.get('/users/self/', { ...options, response: 'json' });
    };
    getRecentViews = async (resourceType, options) => {
        return this.get('/users/self/recent-views', { ...options, query: { resource_type: resourceType }, response: 'json' });
    };
    recordRecentView = async (resourceType, resourceUuid, options) => {
        await this.post('/users/self/recent-views', {
            ...options,
            json: { resource_type: resourceType, resource_uuid: resourceUuid },
            response: 'raw',
        });
    };
    patchCurrentUser = async ({ operations }) => {
        await this.patch('/users/self/', { json: operations, response: 'raw' });
    };
    getUserList = async ({ customerId, orderId, userType, }, options) => {
        const query = {
            ...(customerId ? { customer_uuid: customerId } : {}),
            ...(orderId ? { applicable_to_order: orderId } : {}),
            ...(userType ? { user_type: userType } : {}),
        };
        return this.get('/users/', { ...options, query, response: 'json' });
    };
    uploadProfileImage = async ({ image }) => {
        const formData = new FormData();
        formData.append('file', image);
        await this.post('/users/self/profile-image', { body: formData, response: 'raw' });
    };
    deleteProfileImage = async () => {
        await this.delete('/users/self/profile-image', { response: 'raw' });
    };
}
